import {MainTabItemType} from '../../design-system/organisms/MainTab/MainTabItemType.interface';
import {MyNewsTabType} from '../../graphql/generated/types';

export const MY_NEWS_SLICE_NAME = 'myNews';
export const MY_NEWS_TAB_LIST: MainTabItemType[] = [
  {
    text: '전체',
    textTKey: 'notification_all',
    id: MyNewsTabType.All,
    href: '/mynews',
  },
  {
    text: '내소식',
    textTKey: 'notification_tab_my',
    id: MyNewsTabType.My,
    href: '/mynews/my',
  },
  {
    text: '업데이트',
    textTKey: 'notification_update',
    id: MyNewsTabType.Up,
    href: '/mynews/up',
  },
];

export const LOCAL_STORAGE_LAST_MY_NEWS_LIST_KEY = 'last_my_news_list';
